import styled from 'styled-components';
import { DefaultTheme, colors } from '../../theme';

export const Welcome = styled.div`
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #000;
  margin-bottom: 30px;
`;

export const InfoText = styled.div`
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  margin-bottom: 16px;
`;

export const OptionCard = styled.div`
  display: flex;
  gap: 16px;
  background: white;
  border: 1px solid #bbcad3;
  border-radius: 15px;
  padding: 24px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: none !important;
  overflow: hidden;
  flex-shrink: 0;

  &.selected {
	   border: 1px solid ${colors['dark-slate-blue']};
	   box-shadow: 0 0 0 1px ${colors['dark-slate-blue']};
  }

  &.selected>.radio-circle {
	   border-color: ${colors['dark-slate-blue']};
	   background-color: ${colors['dark-slate-blue']};
	   transition: none !important;
  }

  &.selected>.radio-circle::after {
	   content: "";
	   position: absolute;
	   top: 50%;
     left: 50%;
     width: 12px;
     height: 12px;
     background-color: white;
     border-radius: 50%;
     transform: translate(-50%, -50%);
   }
`;

export const OptionContent = styled.div`
  flex: 1;
`;

export const OptionIcon = styled.img`
  width: 48px;
  height: 48px;
`;

export const RadioCircle = styled.div`
  width: 22px;
  height: 22px;
  border: 2px solid #bbcad3;
  border-radius: 50%;
  margin-left: 16px;
  position: relative;
  transition: none !important;
`;

export const OptionTitle = styled.h2`
  color: ${colors['dark-slate-blue']};
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 18px;
  margin: 0 0 4px;
  text-align: left;
`;

export const OptionDescription = styled.p`
  opacity: 0.8;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.4 !important;
  margin: 0;
  text-align: left;
  color: ${colors['dark-slate-blue']};

  &.height-auto {
    height: auto;
  }
`;

export const OptionInfo = styled.div`
  display: flex;
  gap: 10px;
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  margin-bottom: 0;
`;

export const InfoIcon = styled.img`
  display: block;
  width: 18px;
  height: 18px;
`;
